import { Vue, Component, Emit, Prop, Watch } from "vue-property-decorator";
import Modal from "@/assets/common/Modal/Modal.vue";
import { toCamel } from "snake-camel";
import moment from "moment";
import store from "@/assets/common/store/store";

@Component({
    components: {
        Modal,
    },
})
export default class ProducerApprovalModal extends Vue {
    baseUrl = "/producer_approval";

    @Prop()
    isShowProducerApprovalModal!: boolean;
    @Prop({ default: () => [] }) producerApprovals!: any[];
    @Prop({ required: true }) currentProducerApprovalIndex!: number;
    producerRefereshFlag!: boolean;
    invitedTenantId = ''

    closeModal() {
        this.$emit("update:producerRefereshFlag", false);
        this.$emit('update-inert', false)
        this.$root.$emit('header-inert', false);
        this.$emit("responded");
    }

    @Watch('producerRefereshFlag')
    onModalVisibilityChanged(val: boolean) {
        this.$root.$emit('header-inert', false);
        this.$emit('update-inert', false)
    }

    get currentApproval() {
    if (!this.producerApprovals || this.producerApprovals.length === 0) {
    return {};
    }
    return this.producerApprovals[this.currentProducerApprovalIndex] || {};
    }

    get companyName() {
    return this.currentApproval.companyName;
    }

    get ownerName() {
        return this.currentApproval.ownerName;
    }

    acceptInvite(isAccepted: boolean){
        const approval = this.currentApproval; 
        const message = isAccepted ? `${approval.companyName || approval.ownerName}の集出荷団体テナントに参加しますか?`: `${approval.companyName || approval.ownerName}の集出荷団体テナントに参加しませんか?`;
        const confirmResult = window.confirm(message);
        if (!confirmResult) return;
         this.$apiClient
            .doRequest("put", `${this.baseUrl}/accept_deny_invite`, { tenantId: approval.tenantId, isAccepted: isAccepted })
            .then((res) => {
                const msg = isAccepted ? '集出荷団体テナントに参加しました。' : '集出荷団体テナントに参加しませんでした。';
                this.$toasted.success(msg);
                if(isAccepted){
                this.$apiClient.getUserProfile();
                this.$emit("update:producerRefereshFlag", true);
                }
                this.$root.$emit('header-inert', false);
                this.$emit('update-inert', false)
                this.$emit("responded");
            })
    }
}
